import React from 'react';
import I18n from 'i18n-js';

import { RCMenu } from '@reverbdotcom/cadence/components';
import { MParticleEventName, trackEvent } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import { CoreMyListingAvailableSalesMemberships } from '@reverbdotcom/commons/src/gql/graphql';

interface IExternalProps {
  loading: boolean;
  setIsModalOpen: (isOpen) => void;
  data: CoreMyListingAvailableSalesMemberships.Query;
}

export const COMPONENT_NAME = 'SalesModalButton';

export default function SalesModalButton({
  loading,
  setIsModalOpen,
  data,
}: IExternalProps) {
  const { listing = {} } = data ?? {};
  const { availableSalesMemberships = {} } = listing ?? {} ;
  const { reverbSalesMemberships = [], sellerSalesMemberships = [] } = availableSalesMemberships;
  const inSale = [...reverbSalesMemberships, ...sellerSalesMemberships].some(sale => sale.isListingInSale);
  const buttonText = (loading || inSale) ? I18n.t('discovery.listingsManagement.sellerListingCard.sales.manageSales') : I18n.t('discovery.listingsManagement.sellerListingCard.sales.addToASale');

  function handleClick() {
    setIsModalOpen(true);
    trackEvent({
      eventName: MParticleEventName.ClickedComponent,
      componentName: COMPONENT_NAME,
      listingId: listing.id,
    });
  }

  return (
    <RCMenu.Item onClick={handleClick}>
      {buttonText}
    </RCMenu.Item>
  );
}
